import { render } from "./panel.vue?vue&type=template&id=4230aaf0"
import script from "./panel.vue?vue&type=script&lang=js"
export * from "./panel.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/scada/components/panel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4230aaf0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4230aaf0', __exports__)) {
    console.log('reload')
    api.reload('4230aaf0', __exports__)
  }
  
  module.hot.accept("./panel.vue?vue&type=template&id=4230aaf0", () => {
    console.log('re-render')
    api.rerender('4230aaf0', render)
  })

}


export default __exports__